//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import parser from '@/components/FormGenerator/components/parser/Parser';
import * as logistics from '@/api/logistics.js';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { Debounce } from '@/utils/validate';
export default {
  name: 'CompanyList',
  components: {
    parser: parser
  },
  data: function data() {
    return {
      constants: this.$constants,
      // 表单
      formConf: {
        fields: []
      },
      form: {
        keywords: ''
      },
      tableData: {},
      page: 1,
      limit: 10,
      loading: false,
      dialogVisible: false,
      fromType: 'add',
      formData: {
        name: '',
        code: '',
        sort: 0,
        isShow: 1,
        status: false
      },
      isCreate: 0,
      formShow: false,
      editId: 0,
      rules: {
        name: [{
          required: true,
          message: '请输入物流公司名称',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入物流公司编码',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }]
        // account: [{ required: true, message: '请输入月结账号', trigger: 'blur' }],
        // password: [{ required: true, message: '请输入月结密码', trigger: 'blur' }],
        // netName: [{ required: true, message: '请输入网点名称', trigger: 'blur' }],
      }
    };
  },
  created: function created() {
    if (checkPermi(['platform:express:list'])) this.getExpressList();
  },
  methods: {
    checkPermi: checkPermi,
    handlerSearch: function handlerSearch() {
      this.page = 1;
      this.getExpressList();
    },
    //  获取物流公司列表
    getExpressList: function getExpressList() {
      var _this = this;
      this.loading = true;
      logistics.expressList({
        page: this.page,
        limit: this.limit,
        keywords: this.form.keywords
      }).then(function (res) {
        _this.loading = false;
        _this.tableData = res;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 物流开关
    bindStatus: function bindStatus(item) {
      var _this2 = this;
      logistics.expressUpdateShow({
        account: item.account,
        code: item.code,
        id: item.id,
        isShow: item.isShow,
        name: item.name,
        sort: item.sort
      }).then(function (res) {
        _this2.$message.success('操作成功');
        // this.getExpressList()
      }).catch(function () {
        item.isShow = item.isShow == 1 ? 0 : 1;
      });
    },
    // 分页
    pageChange: function pageChange(e) {
      this.page = e;
      this.getExpressList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.limit = e;
      this.getExpressList();
    },
    // // 添加物流公司
    // addExpress() {
    //   logistics.expressSyncApi().then((res) => {
    //     this.$message.success('同步物流公司成功');
    //     this.page = 1;
    //     this.getExpressList();
    //   });
    // },
    // 删除物流公司
    bindDelete: function bindDelete(item) {
      var _this3 = this;
      this.$modalSure().then(function () {
        logistics.expressDelete({
          id: item.id
        }).then(function (res) {
          _this3.$message.success('删除成功');
          _this3.getExpressList();
        });
      });
    },
    // 表单提交
    submit: Debounce(function (formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var api = _this4.fromType === 'add' ? logistics.expressSave : logistics.expressUpdate;
          var successMsg = _this4.fromType === 'add' ? '新增成功' : '操作成功';
          api(_this4.formData).then(function (res) {
            _this4.$message.success(successMsg);
            _this4.handleClose();
            _this4.getExpressList();
          });
        } else {
          return false;
        }
      });
    }),
    //  关闭模态框
    handleClose: function handleClose(done) {
      this.formShow = false;
      this.formData = {
        name: '',
        code: '',
        sort: 0,
        isShow: 1,
        status: false
      };
      this.formConf.fields = [];
      this.dialogVisible = false;
      this.isCreate = 0;
      this.fromType = 'add';
    },
    // 新增
    bindAdd: function bindAdd() {
      this.fromType = 'add';
      this.dialogVisible = true;
      this.editId = 0;
      this.formData = {
        name: '',
        code: '',
        sort: 0,
        isShow: 1,
        status: false
      };
    },
    // 编辑
    bindEdit: function bindEdit(item) {
      var _this5 = this;
      this.fromType = 'edit';
      this.dialogVisible = true;
      this.editId = item.id;
      logistics.expressInfo({
        id: item.id
      }).then(function (res) {
        _this5.formData = res;
      });
    }
  }
};